import { AssignmentState, Customer, Employee, Interval, Job, ModelObject, Project, Truck } from '@cco/model';

export interface Assignment extends ModelObject<number> {
  uuid: string;
  typeId: number;
  firstStateId: number;
  currentStateId: number;
  stateEntities: { [id: number]: AssignmentState };
  interval: Interval;
  truckId: number;
  driverId: number;
  jobId: number;
  targetId: number;
  batchReportIds: number[];
  details?: {
    customer: Customer;
    project: Project;
    job: Job;
    truck: Truck;
    driver: Employee;
  };
}

export const assignmentComparer = (a: Assignment, b: Assignment) => {
  if (a.interval?.start == null && b.interval?.start == null)
    return 0;
  if (a.interval?.start != null && b.interval?.start == null)
    return 1;
  if (a.interval?.start == null && b.interval?.start != null)
    return -1;

  return b.interval.start?.localeCompare(a.interval.start);
};
